import type { WorktreeLaunchProgress } from "./worktreeLaunchProgress";

// Upstream's SetupDetails is just the dl below (mt-1 mb-1.5 ml-8, gap-y-0.5,
// dt at text-foreground/80) — Forge's progress bundles error/output into the
// same panel upstream shows separately (via a per-stage OutputTail it hasn't
// been ported here), so that part stays Forge's own. The ml-8 indent matches
// this file's own WorktreeLaunchAlerts convention; it was missing here.
export function WorktreeLaunchDetails({ progress }: { readonly progress: WorktreeLaunchProgress }) {
  return (
    <div className="mt-2 max-h-40 overflow-auto border-t border-border pt-2 text-xs text-muted-foreground">
      <dl className="ml-8 grid min-w-0 grid-cols-[auto_1fr] gap-x-3 gap-y-0.5">
        {progress.branch ? (
          <>
            <dt className="text-foreground/80">Branch</dt>
            <dd className="min-w-0 break-all font-mono">{progress.branch}</dd>
          </>
        ) : null}
        {progress.baseBranch ? (
          <>
            <dt className="text-foreground/80">Base</dt>
            <dd className="min-w-0 break-all font-mono">{progress.baseBranch}</dd>
          </>
        ) : null}
        {progress.worktreePath ? (
          <>
            <dt className="text-foreground/80">Path</dt>
            <dd className="min-w-0 break-all font-mono">{progress.worktreePath}</dd>
          </>
        ) : null}
      </dl>
      {progress.error ? (
        <pre className="mt-2 ml-8 whitespace-pre-wrap break-all font-mono">{progress.error}</pre>
      ) : null}
      {progress.output.length ? (
        <pre className="mt-2 ml-8 whitespace-pre-wrap break-all font-mono">
          {progress.output.join("\n")}
        </pre>
      ) : (
        <p className="mt-2 ml-8">No command output yet.</p>
      )}
    </div>
  );
}
